import React from "react";

const AllSpacesContext = React.createContext()

export default AllSpacesContext